import React from 'react';
import { useDrop } from 'react-dnd';
import { FormItemTypes, SystemFields } from './formItemTypes';
import styles from '../template.module.scss';

const DroppableArea = ({ onDrop, children, column, formItems = [] }) => {
  const acceptedTypes = [
    ...FormItemTypes.map(f => f.type),
    ...SystemFields.map(f => f.type)
  ];

  const [{ isOver }, drop] = useDrop({
    accept: acceptedTypes,
    drop: (item) => onDrop(item),
    collect: (monitor) => ({
      isOver: monitor.isOver()
    })
  });

  return (
    <div
      className={styles.droppableArea}
      ref={drop}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${column}, 1fr)`,
        gap: '16px',
        backgroundColor: isOver ? 'var(--palette-gray-5)' : 'var(--palette-gray-1)',
        padding: '16px'
      }}
    >
      {children}
    </div>

  );
};

export default DroppableArea;
